import { useCallback, useState } from 'react'

export default function useTheForce() {
  const [, setForceCount] = useState(0)

  return useCallback(() => {
    setForceCount(prev => prev + 1)
  }, [])
}
